import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Arrow_Btn.css";
import {
    faAngleRight,
    faArrowRight,
    faArrowRightLong,
    faPlay,
} from "@fortawesome/free-solid-svg-icons";

const Arrow_Btn = ({ btnText, type, onClick}) => {
    return (
        <button
            className="Arrow_Btn"
            type={type ? type : "button"}
            onClick={onClick}
        >
            <p className="btn_text">{btnText}</p>
            <div className="arrow_div">
                <FontAwesomeIcon icon={faArrowRightLong} className="arrow_text" />
            </div>
        </button>
    );
};

export default Arrow_Btn;
